"use client";
import { useEffect } from "react";

export default function ScrollShadow({ targetId = "site-nav" }: { targetId?: string }) {
  useEffect(() => {
    const element = document.getElementById(targetId);
    if (!element) return;

    const set = () => {
      const scrolled = window.scrollY > 0;
      element.dataset.scrolled = scrolled ? "true" : "false";
    };

    set();
    const onScroll = () => requestAnimationFrame(set);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [targetId]);

  return null;
}


